const GoogleIcon = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.8 10.7084C18.8 10.0584 18.7417 9.43337 18.6333 8.83337H10V12.3834H14.9333C14.7167 13.525 14.0667 14.4917 13.0917 15.1417V17.45H16.0667C17.8 15.85 18.8 13.5 18.8 10.7084Z"
      fill="#4285F4"
    />
    <path
      d="M10.0002 19.6667C12.4752 19.6667 14.5502 18.85 16.0669 17.45L13.0919 15.1417C12.2752 15.6917 11.2336 16.025 10.0002 16.025C7.61689 16.025 5.59189 14.4167 4.86689 12.25H1.81689V14.6167C3.32523 17.6083 6.41689 19.6667 10.0002 19.6667Z"
      fill="#34A853"
    />
    <path
      d="M4.86683 12.2417C4.6835 11.6917 4.57516 11.1084 4.57516 10.5001C4.57516 9.89172 4.6835 9.30839 4.86683 8.75839V6.39172H1.81683C1.19183 7.62506 0.833496 9.01672 0.833496 10.5001C0.833496 11.9834 1.19183 13.3751 1.81683 14.6084L4.19183 12.7584L4.86683 12.2417Z"
      fill="#FBBC05"
    />
    <path
      d="M10.0002 4.98337C11.3502 4.98337 12.5502 5.45004 13.5086 6.35004L16.1336 3.72504C14.5419 2.24171 12.4752 1.33337 10.0002 1.33337C6.41689 1.33337 3.32523 3.39171 1.81689 6.39171L4.86689 8.75837C5.59189 6.59171 7.61689 4.98337 10.0002 4.98337Z"
      fill="#EA4335"
    />
  </svg>
);

export default GoogleIcon;
